var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pick-deck"},[_c('h3',{staticClass:"pick-deck__title"},[_vm._v(_vm._s(_vm.title))]),_c('HearthstonePick',{on:{"done":_vm.emitDecks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }